import ApiClient from "@/libs/http-client";


const AutomationService = {
    endpoints(route, params) {
      const url = {
        tasks: "/api/automation/tasks",
        changeTask: `/api/automation/tasks/${params}`,
        types: "/api/automation/types",
        statuses: "/api/automation/statuses",
        priorities: "/api/automation/priorities",
      };
  
      return url[route];
    },
  
    get(url, params={}) {
      return ApiClient.get(this.endpoints(url), { params });
    },
    getById(url, params='') {
        return ApiClient.get(this.endpoints(url, params));
      },
    post(url, data, config = {}) {
      return ApiClient.post(this.endpoints(url), data, config);
    },
    put(url, params={}, data, config={}){
        return ApiClient.put(this.endpoints(url, params), data, config);
    },
    delete(url, params={}, config={}){
        return ApiClient.delete(this.endpoints(url, params), config);
    }
  };
  
export default AutomationService;